__turbopack_context__.v({
  "hidden": "InlineTooltip-module__T7N4qq__hidden",
  "inlineTooltip": "InlineTooltip-module__T7N4qq__inlineTooltip",
  "left": "InlineTooltip-module__T7N4qq__left",
  "tooltipText": "InlineTooltip-module__T7N4qq__tooltipText",
});
